<template>
  <div>
    <v-row justify="center">
      <v-btn
        v-if="show_btn"
        color="primary"
        class="ma-2"
        dark
        @click="dialog = true"
        >+ 新規登録</v-btn
      >
      <v-dialog v-model="dialog" max-width="1000px">
        <!-- <loadingDialog :show="loading"></loadingDialog> -->
        <v-card class="pa-2">
          <v-card-actions>
            <v-card-title>カテゴリ編集</v-card-title>
            <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn v-if="showDelete()" color="red" text @click="deleteItem()">
              <v-icon>mdi-delete</v-icon>削除
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="save()">
              <v-icon>mdi-content-save</v-icon>保存
            </v-btn>
          </v-card-actions>
            <v-btn color="primary" text @click="dialog = false">閉じる</v-btn>
          </v-card-actions>

          <v-card-text>
            <v-row dense>
              <v-col cols="9" class="pl-2">
                <v-icon color="green darken-2" class="aaaa">
                  mdi-drag-vertical </v-icon
                >をドラッグで並び替えができます。
              </v-col>
              <v-col cols="3">
                表示・非表示切り替え ↓
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text>
            <ul style="list-style:none;padding:0;">
              <draggable
                v-model="item_list"
                draggable=".item"
                :options="{ handle: '.drag' }"
                group="items"
              >
                <li
                  v-for="item in item_list"
                  :key="item.id"
                  class="item pa-1"
                  max-width="100"
                  style="display:block; width:100%;vertical-align: top;"
                >
                  <v-card
                    class="pa-2"
                    @click="editData(item)"
                    dense
                    :class="{ disable: item.delete_flg == 1 }"
                  >
                    <v-row dense>
                      <v-col cols="1" class="drag">
                        <v-icon color="green darken-2">
                          mdi-drag-vertical
                        </v-icon>
                      </v-col>

                      <v-col cols="3">
                        {{ item.release }}
                      </v-col>

                      <v-col cols="6">
                       {{ item.title }}
                      </v-col>

                    </v-row>
                  </v-card>
                </li>
              </draggable>
            </ul>
          </v-card-text>

        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
/* -----------------------------
   タグの新規登録・更新処理 
------------------------------*/

// Ajax通信ライブラリ
import axios from "axios";
import draggable from "vuedraggable";

// import loadingDialog from "@/components/Loading";

export default {
  components: {
    // loadingDialog,
    draggable,
  },

  data() {
    return {
      item_list: [],
      headers: [
        { text: "編集", value: "edit", width: "60px", align: "center" },

        { text: "id", value: "id", width: "44px", align: "center" },
        { text: "タイトル名", value: "title", width: "300px" },

        // { text: "", value: "memo", width: "20px", fixed: true },
        // { text: "source", value: "source", width: "114px",align: "left", fixed: true },
        // { text: "編集", value: "edit", width: "60px" }
      ],
      search: "",

      name: "カテゴリ",
      dialog: false,
      item: {},
      loading: false,
      type: "new",
    };
  },

  props: {
    show_btn: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    dialog: function() {
      if (this.dialog && this.type == "new") {
        this.item = {
          id: -1,
          title: "",
          delete_flg: 0,
          selected: 0,
        };
      }
    },
  },

  methods: {
    editItem(item) {
      this.type = "edit";
      this.item = Object.assign({}, item);
      this.dialog = true;
    },

    newItem(items) {
      this.item_list = Object.assign([], items);

      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    showDelete() {
      if (this.type == "edit") {
        return true;
      } else {
        return false;
      }
    },

    deleteItem() {
      // var result = confirm("削除しますか？");
      // if (result) {
      //   this.loading = true;
      //   this.item.delete_flg = 1;
      //   const response = this.$axios
      //     .$post(process.env.API_URL + "/label_update", {
      //       data: this.item,
      //     })
      //     .then((response) => {
      //       this.dialog = false;
      //       console.log(response);
      //       this.$emit("itemUpdate", this.item);
      //     })
      //     .catch((error) => {
      //       alert("予期せぬエラーが発生しました");
      //       this.dialog = false;
      //     })
      //     .finally(() => {
      //       this.loading = false;
      //     });
      // }
    },
    save() {
      // this.loading = true;

      var self = this;
      axios
        .post(process.env.VUE_APP_CALENDAR_LIST_SORT, {
          data: this.item_list,
        })
        .then(function(response) {

          console.log("aaaa",self.item_list[0].title)
          // self.item.id = response.data.last_id;
          self.$emit("sortArticleUpdate", self.item_list);

          console.log(response);
          self.close();
        });
    },
  },
};
</script>
<style>
.disable {
  background: #999 !important;
  opacity: 0.5;
}
</style>
